import { serviceApiService } from "../hooks/useProductFromCollectionById/service-api-instance";
import { IProductWithCmsDataAndQualification } from "../pages/ProductsListPage/entities/product-with-cms-data-and-qualification/product-with-cms-data-and-qualification.entity.interface";

export async function fetchProductsData(): Promise<IProductWithCmsDataAndQualification[]> {
  const products = await serviceApiService.getAllProducts();
  return products ?? [];
}
